export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Categories.vue?vue&type=template&id=445221d0"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Categories.vue?vue&type=template&id=445221d0
// module id = 84
// module chunks = 0